/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: index.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  05.07.22 10:12 am.
 * Last modified: 05.07.22 10:12 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { getBackgroundSettings } from '../api/helpers';
import store from '../eventStore';
import Body from './Body';
import Grid from './Grid';
import Header from './Header';

const Section = ({
    group,
    count,
    blocks,
    label,
    isViewingAll,
    noHeader,
    onClickViewAll,
    onClickIcon,
    children,
    jackpotComponent,
    placeholder,
    mode,
    visible,
}: ISectionProps) => {
    const hasJackpotComponent = Boolean(jackpotComponent);
    const [backgroundSettings] = getBackgroundSettings(store.SETTINGS.value, group.toLowerCase(), true);

    return (
        <div
            style={!visible ? { display: 'none' } : isViewingAll ? backgroundSettings : {}}
            className={`egt_section egt_section_${mode} ${
                isViewingAll ? 'egt_section_fullscreen' : ''
            } egt_section_${group
                .split(' ')
                .join('_')
                .toLowerCase()} ${group.toLowerCase().indexOf('tournament') !== -1 ? 'egt_section_tournament' : ''}
            ${hasJackpotComponent && !isViewingAll ? 'egt_section_with_left_jp' : ''}`}
        >
            {!noHeader && (
                <Header
                    icon={`${group}_icon`}
                    label={label}
                    count={count}
                    isViewingAll={isViewingAll}
                    onClickViewAll={onClickViewAll}
                    onClickIcon={onClickIcon}
                />
            )}
            {Boolean(placeholder) && count === 0 && placeholder}
            <Body group={group} jackpotComponent={jackpotComponent} singleView={isViewingAll}>
                <Grid count={blocks} maxRows={!isViewingAll ? 2 : 0} name={group}>
                    {children}
                </Grid>
            </Body>
        </div>
    );
};

export interface ISectionProps {
    count: number;
    blocks: number;
    label: string;
    group: string;
    isViewingAll?: boolean;
    noHeader?: boolean;
    onClickViewAll?: () => void;
    onClickIcon?: () => void;
    jackpotComponent?: React.FunctionComponent;
    placeholder?: React.ReactNode;
    children: React.ReactNode;
    mode: 'desktop' | 'mobile';
    visible?: boolean;
}

Section.defaultProps = {
    noHeader: false,
    visible: true,
};

export default Section;
